import React, { useState, useEffect } from 'react';
import './Slide.css'; 

const Slide = () => {
  const [visible, setVisible] = useState(false);
  const [animation, setAnimation] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(true);
      setAnimation('slide-in');

      setTimeout(() => {
        setAnimation('slide-out');
        setTimeout(() => setVisible(false), 1000);
      }, 10000);
    }, 120000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`animated-frame ${animation}`} style={{ display: visible ? 'block' : 'none' }}>
      <a target='_blank' href="">Subscribe to the telegram!</a>
    </div>
  );
};

export default Slide;